import React, { useEffect, useState } from 'react';
import shoorahLogo from '../../assets/images/shoorah-logo.jpg';
import { Api } from '../../api';
import { isCopanySuperOrSubAdmin, isSuperAndSubAdmin } from '../../utils/helper';
import DonutChartCard from '../../component/common/cards/DonutChartCard';
import { CompanyApi } from '../../api/companyApi';
import { useLocation } from 'react-router-dom';
import CommonProgressBar from '../../component/common/Input/CommonProgressBar';
import { DashboardContent, DonutChartCardData } from '../../utils/pageContent';

const DashboardAssesmentCard = () => {
  const [assessmentData, setAssessmentData] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [option, setOption] = useState(0);
  const location = useLocation();
  const company = location.state;
  const assessmentCardData = DashboardContent.assessmentCardContent;

  const commonOutcome = assessmentData?.outComeType?.[0]?.types?.sort(
    (a, b) => b?.count - a?.count
  );
  const commonOutcomeName = ['Percentage', 'Attachment'];
  const TopAssesment = assessmentData?.outCome?.[0];

  const fetchassessmentData = () => {
    if (isSuperAndSubAdmin()) {
      Api.getAssessmentMatrics(company?._id).then((response) => {
        if (response?.data?.meta?.code === 1) {
          setAssessmentData(response?.data?.data);
        }
      });
    } else if (isCopanySuperOrSubAdmin()) {
      CompanyApi.getAssessmentMatrics().then((response) => {
        setAssessmentData(response?.data?.data);
      });
    }
  };

  useEffect(() => {
    fetchassessmentData();
  }, []);

  const dataD = {
    labels: [DonutChartCardData.responses, DonutChartCardData.noResponse],
    datasets: [
      {
        label: DonutChartCardData.modalLabel,
        data: [1135, 365],
        backgroundColor: ['#F05289', '#FF9BCB'],
        hoverBackgroundColor: ['#F05289', '#FF9BCB'],
        borderWidth: 1,
        borderRadius: 10,
        borderJoinStyle: 'round'
      }
    ]
  };
  const completePercentage =
    ((assessmentData?.assessment?.completedCount ? assessmentData?.assessment?.completedCount : 0) *
      100) /
    (assessmentData?.assessment?.total ? assessmentData?.assessment?.total : 1);
  const inCompletePercentage =
    ((assessmentData?.assessment?.inCompletedCount
      ? assessmentData?.assessment?.inCompletedCount
      : 0) *
      100) /
    (assessmentData?.assessment?.total ? assessmentData?.assessment?.total : 1);

  const totalCompleteAssesment = assessmentData?.assessment?.completedCount
    ? assessmentData?.assessment?.completedCount
    : 0;
  const completeAssessment = [
    {
      label: assessmentCardData.completedAssessments.completed,
      value: assessmentData?.assessment?.completedCount
        ? assessmentData?.assessment?.completedCount
        : 0,
      percentage: completePercentage === NaN ? 0 : completePercentage.toFixed(0),
      color: '#D97F56'
    },
    {
      label: assessmentCardData.completedAssessments.inComplete,
      value: assessmentData?.assessment?.inCompletedCount
        ? assessmentData?.assessment?.inCompletedCount
        : 0,
      percentage: inCompletePercentage === 'NaN' ? 0 : inCompletePercentage.toFixed(0),
      color: '#ECC09E'
    }
  ];

  const options = [
    {
      label: assessmentCardData.averageScore.text1,
      value: assessmentData?.scoreRanges?.[0]?.count + assessmentData?.scoreRanges?.[1]?.count || 0,
      color: '#67A14A'
    },
    {
      label: assessmentCardData.averageScore.text2,
      value: assessmentData?.scoreRanges?.[2]?.count + assessmentData?.scoreRanges?.[3]?.count || 0,
      color: '#D97F56'
    },
    {
      label: assessmentCardData.averageScore.text3,
      value: assessmentData?.scoreRanges?.[4]?.count + assessmentData?.scoreRanges?.[5]?.count || 0,
      color: '#67A14A'
    },
    {
      label: assessmentCardData.averageScore.text4,
      value: assessmentData?.scoreRanges?.[6]?.count + assessmentData?.scoreRanges?.[7]?.count || 0,
      color: '#D97F56'
    }
  ];

  const UserAvrageScoresData1 = [
    {
      label: assessmentData?.scoreRanges?.[0]?._id,
      value: assessmentData?.scoreRanges?.[0]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[0]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[0]?.percentage?.toFixed(1),
      color: '#21BDAD'
    },
    {
      label: assessmentData?.scoreRanges?.[1]?._id,
      value: assessmentData?.scoreRanges?.[1]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[1]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[1]?.percentage?.toFixed(1),
      color: '#6BE0BD'
    }
  ];

  const UserAvrageScoresData2 = [
    {
      label: assessmentData?.scoreRanges?.[2]?._id,
      value: assessmentData?.scoreRanges?.[2]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[2]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[2]?.percentage?.toFixed(1),
      color: '#21BDAD'
    },
    {
      label: assessmentData?.scoreRanges?.[3]?._id,
      value: assessmentData?.scoreRanges?.[3]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[3]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[3]?.percentage?.toFixed(1),
      color: '#6BE0BD'
    }
  ];

  const UserAvrageScoresData3 = [
    {
      label: assessmentData?.scoreRanges?.[4]?._id,
      value: assessmentData?.scoreRanges?.[4]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[4]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[4]?.percentage?.toFixed(1),
      color: '#21BDAD'
    },
    {
      label: assessmentData?.scoreRanges?.[5]?._id,
      value: assessmentData?.scoreRanges?.[5]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[5]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[5]?.percentage?.toFixed(1),
      color: '#6BE0BD'
    }
  ];
  const UserAvrageScoresData4 = [
    {
      label: assessmentData?.scoreRanges?.[6]?._id,
      value: assessmentData?.scoreRanges?.[6]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[6]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[6]?.percentage?.toFixed(1),
      color: '#21BDAD'
    },
    {
      label: assessmentData?.scoreRanges?.[7]?._id,
      value: assessmentData?.scoreRanges?.[7]?.percentage?.toFixed(1),
      percentage:
        assessmentData?.scoreRanges?.[7]?.percentage?.toFixed(1) === 'NaN'
          ? 0
          : assessmentData?.scoreRanges?.[7]?.percentage?.toFixed(1),
      color: '#6BE0BD'
    }
  ];

  const UserAvrageScoresData =
    option === 0
      ? UserAvrageScoresData1
      : option === 1
        ? UserAvrageScoresData2
        : option === 2
          ? UserAvrageScoresData3
          : UserAvrageScoresData4;

  const totalAvgScore =
    assessmentData?.averageScore?.toFixed(1) ||
    UserAvrageScoresData?.map((item) => item.value)
      .reduce((a, b) => +a + +b, 0)
      ?.toFixed(1);

  const ProgressBar = ({ label, percentage }) => (
    <div className="">
      {!!label && (
        <div className="flex justify-between items-center mb-1">
          <span className="text-lg font-normal">{label}</span>
          <span className="text-sm text-green-600">{percentage}%</span>
        </div>
      )}
      <div className="w-full bg-[#FF9BCB] rounded-full h-2">
        <div className="bg-[#F05289] h-2 rounded-full" style={{ width: `${percentage}%` }}></div>
      </div>
    </div>
  );

  return (
    <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 dark:bg-shoorah-darkBgTabColor dark:border-none dark:text-shoorah-darkBg bg-white">
      <div className="text-lg lg:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
        {assessmentCardData.title}
      </div>
      <div className="text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-[400]">
        {assessmentCardData.description}
      </div>
      <div className="flex sm:flex-row flex-col mt-6 gap-4 2xl:gap-7 overflow-x-auto horizontal-card-scrollbar">
        <div className="flex flex-col sm:flex-row lg:flex-row md:flex-row gap-4 2xl:gap-7 sm:w-auto sm:min-w-[420px] 2xl:min-w-[432px]">
          <DonutChartCard
            data={completeAssessment}
            title={assessmentCardData.completedAssessments.title}
            totalAgeEngagements={totalCompleteAssesment}
            className={
              'dark:!bg-shoorah-darkBgColor dark:!border-none flex flex-col justify-between'
            }
          />
          <DonutChartCard
            data={UserAvrageScoresData}
            title={assessmentCardData.averageScore.title}
            options={options}
            open={isOpen}
            option={option}
            totalAgeEngagements={totalAvgScore}
            setOption={setOption}
            setOpen={setIsOpen}
            range={true}
            circleClassName="w-[105px] h-[105px]"
            className={
              'dark:!bg-shoorah-darkBgColor dark:!border-none flex flex-col justify-between'
            }
          />
          <div className="md:p-6 p-4 w-full sm:mb-0 min-w-full gap-2 sm:min-w-[202px] bg-[#FFFFFF] rounded-xl border border-[#E7E8EA]">
            <h2
              className={`lg:text-[20px] text-[18px] font-medium text-[#0B0F18] text-left dark:text-shoorah-darkBg mb-5`}
            >
              {assessmentCardData.averageScore.top5Assessments}
            </h2>
            <div className="grid grid-cols-1 gap-2">
              {assessmentData?.outCome?.length > 0 ? (
                assessmentData?.outCome?.map((item, index) => (
                  <div
                    key={index}
                    title={item?.title}
                    className="border-[1.5px] border-shoorah-borderLight rounded-[10px] px-4 py-[11px] flex items-center md:gap-6 gap-4"
                  >
                    <span className="md:text-[16px] text-[14px] leading-5 text-[#606060] md:w-[calc(100%-100px)] w-[calc(100%-80px)] line-clamp-1">
                      {item?.title}
                    </span>
                    <div className="md:w-[100px] w-[80px]">
                      <CommonProgressBar percentage={item?.percentage} />
                    </div>
                  </div>
                ))
              ) : (
                <div className="w-full h-full flex items-center justify-center mt-[65px]">
                  {assessmentCardData.averageScore.assessmentNotFound}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAssesmentCard;
